import { z } from 'zod';

export const ApplyingCollegeChecklistDocumentSchema = z.object({
  fieldName: z.string(),
  label: z.string(),
});
export type ApplyingCollegeChecklistDocument = z.infer<typeof ApplyingCollegeChecklistDocumentSchema>;
